import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import './i18n';
import App from './App';
import { installMorisawaWebfont } from './utils/morisawaWebfont';

installMorisawaWebfont();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);